import React, { useState } from 'react';
import { Button } from './Button';
import { MenuIcon, X as CloseIcon, ShoppingCart } from 'lucide-react';
export const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navLinks = [{
    label: 'Home',
    href: '#home'
  }, {
    label: 'Shop',
    href: '#shop'
  }, {
    label: 'Customize',
    href: '#customize'
  }, {
    label: 'Contact',
    href: '#contact'
  }];
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
    setIsMenuOpen(false);
  };
  return <header className="w-full bg-white sticky top-0 z-50 shadow-sm" data-id="element-149">
      <div className="container mx-auto px-4 py-4 flex items-center justify-between" data-id="element-150">
        {/* Logo */}
        <div className="flex items-center" data-id="element-151">
          <a href="#home" onClick={e => handleNavClick(e, '#home')} className="text-2xl font-bold text-[#00b8c4]" data-id="element-152">
            StickerJoy
          </a>
        </div>
        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center space-x-8" data-id="element-153">
          {navLinks.map(link => <a key={link.href} href={link.href} onClick={e => handleNavClick(e, link.href)} className="text-gray-700 hover:text-[#ff6b6b] font-medium transition-colors" data-id="element-154">
              {link.label}
            </a>)}
        </nav>
        {/* Desktop Action Buttons */}
        <div className="hidden md:flex items-center space-x-4" data-id="element-155">
          <Button primary={false} size="small" data-id="element-156">
            Log In
          </Button>
          <div className="relative" data-id="element-157">
            <ShoppingCart className="h-6 w-6 text-gray-700 hover:text-[#ff6b6b] cursor-pointer" data-id="element-158" />
            <span className="absolute -top-2 -right-2 bg-[#ff6b6b] text-white text-xs rounded-full h-5 w-5 flex items-center justify-center" data-id="element-159">
              3
            </span>
          </div>
        </div>
        {/* Mobile Menu Button */}
        <button className="md:hidden text-gray-700" onClick={() => setIsMenuOpen(!isMenuOpen)} aria-label="Toggle menu" data-id="element-160">
          {isMenuOpen ? <CloseIcon size={24} data-id="element-161" /> : <MenuIcon size={24} data-id="element-162" />}
        </button>
      </div>
      {/* Mobile Menu */}
      {isMenuOpen && <div className="md:hidden bg-white shadow-lg" data-id="element-163">
          <div className="container mx-auto px-4 py-4 flex flex-col space-y-4" data-id="element-164">
            {navLinks.map(link => <a key={link.href} href={link.href} onClick={e => handleNavClick(e, link.href)} className="text-gray-700 hover:text-[#ff6b6b] font-medium py-2 transition-colors" data-id="element-165">
                {link.label}
              </a>)}
            <div className="flex items-center justify-between pt-2" data-id="element-166">
              <Button primary={false} size="small" data-id="element-167">
                Log In
              </Button>
              <div className="relative" data-id="element-168">
                <ShoppingCart className="h-6 w-6 text-gray-700" data-id="element-169" />
                <span className="absolute -top-2 -right-2 bg-[#ff6b6b] text-white text-xs rounded-full h-5 w-5 flex items-center justify-center" data-id="element-170">
                  3
                </span>
              </div>
            </div>
          </div>
        </div>}
    </header>;
};